export const DELIVERY_STATUS_TEXT = Object.freeze({
  serviceable: "Delivers to your area",
  not_serviceable: "Not available in your area",
  unverified: "Not confirmed yet",
  checking: "Checking...",
});

export const DELIVERY_STATUS_ERROR = "Couldn't load status. Try again";
export const DELIVERY_STATUS_FOOTER = "We re-check for you. But always confirm on the app.";
export const DELIVERY_STATUS_POLL_INTERVAL_MS = 20_000;
export const DELIVERY_STATUS_POLL_WINDOW_MS = 3 * 60 * 1000;
export const DELIVERY_STATUS_POLL_LIMIT = DELIVERY_STATUS_POLL_WINDOW_MS / DELIVERY_STATUS_POLL_INTERVAL_MS;

export function shouldPollDeliveryStatus(platforms, pollCount, hidden, failed = false, loading = false) {
  if (hidden || failed || loading || pollCount >= DELIVERY_STATUS_POLL_LIMIT) return false;
  return platforms.some(({ status }) => status === "checking" || status === "unverified");
}

export function deliveryStatusIcon(platforms, loading) {
  if (loading || platforms.some(({ status }) => status === "checking")) return "checking";
  if (platforms.length === 3 && platforms.every(({ status }) => status === "serviceable")) return "serviceable";
  return "attention";
}

export function updatedAgo(value, current = Date.now()) {
  if (!value) return "Not checked yet";
  const seconds = Math.max(0, Math.floor((current - new Date(value).getTime()) / 1000));
  if (seconds < 60) return "Updated less than a minute ago";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `Updated ${minutes} ${minutes === 1 ? "minute" : "minutes"} ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `Updated ${hours} ${hours === 1 ? "hour" : "hours"} ago`;
  const days = Math.floor(hours / 24);
  return `Updated ${days} ${days === 1 ? "day" : "days"} ago`;
}